import { createTheme } from '@mui/material/styles';

const IDCGTheme = createTheme({
  palette: {
    primary: {
      main: '#043D4E'
    },
    secondary: {
      main: '#634F7D'
    },
    warning: {
      main: '#CB8423'
    },
    info: {
      main: '#4CA1AB'
    },
    success: {
      main: '#6D9D78'
    },
    error: {
      main: '#bd4257'
    },
    text: {
      primary: "#000000",
      secondary: "#5d6164",
      disabled: "#5d6164",
    }
  },
  typography: {
    fontFamily: "Inter",
    fontWeightRegular: 360,
    fontWeightBold: 630,
    h1: {
      fontFamily: "Bitter",
      fontSize: "40px",
      fontWeight: 630,
      lineHeight: "initial"
    },
    h2: {
      fontSize: "24px",
      lineHeight: "initial"
    },
    subtitle1: {
      fontSize: "18px",
      lineHeight: "initial"
    },
    body1: {
      fontSize: "16px",
      lineHeight: "initial"
    },
    body2: {
      fontSize: "16px",
      lineHeight: "initial"
    },
    button: {
      fontSize: "14px",
      textTransform: "none",
    },
    subtitle2: {
      fontSize: "14px",
      lineHeight: "initial",
      fontWeight: 360
    }
  }
});

export default IDCGTheme;
